import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../../axiosConfig";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import TableContainer from "../../../Components/Common/TableContainer";
import { withRouter } from "react-router-dom";
import Loader from "../../../Components/Common/Loader";

function formaterMontant(montant) {
  if (!montant) return "";
  return Number(montant).toLocaleString("fr-FR") + " XOF";
}

const AllRemboursement = (props) => {
  const [remboursements, setRemboursements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRemboursements = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/allremboursement");
        if (res.data && Array.isArray(res.data)) {
          setRemboursements(res.data);
        } else {
          toast.warn("Aucun plan de remboursement trouvé.");
        }
      } catch (err) {
        toast.error("Erreur lors du chargement des remboursements.");
      }
      setLoading(false);
    };
    fetchRemboursements();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Conducteur",
        accessor: "first_name",
        Cell: ({ row }) => (
          <>
            <div>
              <strong>
                {row.original.first_name} {row.original.last_name}
              </strong>
            </div>
            <div>
              <span className="text-muted" style={{ fontSize: "0.95em" }}>
                {row.original.telephone}
              </span>
            </div>
          </>
        ),
      },
      {
        Header: "Type engin",
        accessor: "type_engin",
        filterable: true,
      },
      {
        Header: "Plan",
        accessor: "plan_titre",
        filterable: true,
      },
      {
        Header: "Montant total",
        accessor: "montant_total",
        Cell: ({ value }) => <span>{formaterMontant(value)}</span>,
      },
      {
        Header: "Montant payé",
        accessor: "montant_deja_paye",
        Cell: ({ value }) => <span>{formaterMontant(value)}</span>,
      },
      {
        Header: "Montant restant",
        accessor: "montant_restant",
        Cell: ({ value }) => <span>{formaterMontant(value)}</span>,
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <ul className="justify-content-center list-inline hstack gap-2 mb-0">
            <li className="list-inline-item" title="Voir">
              <button
                className="text-success border-0 bg-transparent d-inline-block"
                size="sm"
                onClick={() =>
                  props.history.push(`/remboursement-detail/${row.original.user_id}`)
                }
              >
                <i className="ri-eye-fill align-bottom"></i>
              </button>
            </li>
          </ul>
        ),
      },
    ],
    [props.history]
  );

  document.title = "Tous les remboursements | Takci";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Tous les remboursements" pageTitle="Takci" />
        <Row>
          <Col lg={12}>
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Liste des plans de remboursement</h5>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  {loading ? (
                    <div className="text-center my-5">
                      <Loader style={{ color: "#014c94" }} />
                      <h2>Chargement...</h2>
                    </div>
                  ) : (
                    <>
                      {remboursements.length > 0 ? (
                        <TableContainer
                          columns={columns}
                          data={remboursements}
                          isGlobalFilter={true}
                          isAddUserList={false}
                          customPageSize={8}
                          className="custom-header-css"
                          divClass="table-responsive table-card mb-3"
                          tableClass="align-middle table-nowrap"
                          theadClass="table-light"
                          loading={loading}
                        />
                      ) : (
                        <Card>
                          <CardBody className="p-4 border-top border-top-dashed">
                            <h6 className="text-muted text-uppercase fw-semibold mb-4">
                              Aucune donnée disponible
                            </h6>
                          </CardBody>
                        </Card>
                      )}
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer closeButton={false} />
      </Container>
    </div>
  );
};

export default withRouter(AllRemboursement);
